import { render, staticRenderFns } from "./BenefitList.vue?vue&type=template&id=695e0556&scoped=true"
import script from "./BenefitList.vue?vue&type=script&lang=js"
export * from "./BenefitList.vue?vue&type=script&lang=js"
import style0 from "./BenefitList.vue?vue&type=style&index=0&id=695e0556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695e0556",
  null
  
)

export default component.exports